import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useGetSettings } from 'pages/AdminManagement/Settings/hooks/use-get-settings';
import { useSettingsState } from 'pages/AdminManagement/Settings/hooks/use-settings-state';
import { adminActions } from 'store/admin/slices';
import { generateWatermarkText } from 'pages/AdminManagement/Settings/helper';
import {
  DEFAULT_COLOR,
  DEFAULT_FONTSIZE,
  DEFAULT_OPACITY,
  DEFAULT_REPEAT,
  DEFAULT_ROTATE,
} from 'pages/AdminManagement/Settings/static';
import { userSelectors } from '../../store/user/selectors';
import { StyledWatermark } from './styles';

interface WatermarkProps {
  className?: string;
}

export const Watermark: React.FC<WatermarkProps> = ({ className }) => {
  const [backgroundImage, setBackgroundImage] = useState<string>('');
  const dispatch = useDispatch();
  const user = useSelector(userSelectors.getUser);
  useGetSettings();
  const { settings, isSettingsLoading, isUpdateSettingsLoading } = useSettingsState();

  useEffect(() => {
    dispatch(adminActions.systemSettings.requestGetSettings());
  }, [isUpdateSettingsLoading]);

  useEffect(() => {
    const rotate = settings ? settings?.watermarkRotation : DEFAULT_ROTATE;
    const opacity = settings ? settings?.watermarkOpacity : DEFAULT_OPACITY;
    const repeat = settings ? settings?.watermarkRepeatPeriod : DEFAULT_REPEAT;
    const fontSize = settings ? settings?.watermarkFontSize : DEFAULT_FONTSIZE;
    const color = settings ? settings?.watermarkColor : DEFAULT_COLOR;
    const createWatermarkSVG = () => {
      const text = generateWatermarkText(settings, isSettingsLoading, user);

      // Create SVG with the watermark text
      const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="${repeat}" height="${repeat}">
          <text
            x="50%"
            y="50%"
            dominant-baseline="middle"
            text-anchor="middle"
            transform="rotate(${rotate} ${repeat / 2} ${repeat / 2})"
            font-family="Arial, sans-serif"
            font-size="${fontSize}px"
            font-weight="bold"
            fill="${color}"
            opacity="${opacity}"
          >
            ${text}
          </text>
        </svg>
      `;

      // Convert SVG to data URL
      const encodedSVG = encodeURIComponent(svg);
      return `data:image/svg+xml,${encodedSVG}`;
    };

    setBackgroundImage(createWatermarkSVG());
  }, [isSettingsLoading]);

  return <StyledWatermark backgroundImage={backgroundImage} zIndex={1000} className={className} />;
};
